export interface MissionStop {
    stationName: string;
    arrivalTime: string; // HH:mm
    pk: number;
}

export interface Mission {
    id: string;
    trainNumber: string;
    lineName: string;
    stops: MissionStop[];
}

export const INITIAL_MISSIONS: Mission[] = [];

export const PERMANENT_MISSIONS: Mission[] = [
    {
        id: 'permanent-1',
        trainNumber: 'MANOEUVRE',
        lineName: 'Manoeuvre locale',
        stops: []
    },
    {
        id: 'permanent-2',
        trainNumber: 'EVOLUTION',
        lineName: 'Evolution Dépôt',
        stops: []
    },
    {
        id: 'permanent-3',
        trainNumber: 'MI',
        lineName: 'Marche Indéterminée',
        stops: []
    }
];
